import { useMutation } from '@apollo/client/react';
import { useCallback, useState } from 'react';

import {
  FinishCheckinEntryDocument,
  GetCheckinEntryDetailDocument,
} from '~/graphql/generated/graphql';

export const useFinishCheckinEntry = (checkinEntryId: string) => {
  const [finishCheckinEntry, { loading: finishing }] = useMutation(FinishCheckinEntryDocument, {
    refetchQueries: [{ query: GetCheckinEntryDetailDocument, variables: { id: checkinEntryId } }],
  });
  const [error, setError] = useState<string | null>(null);

  const finish = useCallback(async () => {
    if (!checkinEntryId) return;

    setError(null);

    try {
      await finishCheckinEntry({
        variables: {
          input: {
            checkinEntryId,
          },
        },
      });
    } catch (error) {
      setError(error?.message || 'エラーが発生しました');
      throw error;
    }
  }, [checkinEntryId, finishCheckinEntry]);

  return { finish, finishing, error };
};
